export const UsersModuleTranslations: Array<string> = [
  // titles
  'AddEditUser.Users',
  'Admin.SetupSpa.Users.Edit',
  'Admin.deflusersetup.LabelGuestUser',
  'Admin.AddEditPermission.LabelAvailableUTP',
  'Admin.AddEditPermission.LabelAvailableUTP.Edit',
  'Admin.QPEdit.Permissions',
  'Admin.QPEdit.Permissions.Edit',
  'UserCustomFields.Title.Edit',
  'UserCustomFields.Title',
  'Admin.Companies',
  'Admin.Companies.Edit',
  // users
  'Admin.Admin.users_list.TViewColUser',
  'Admin.Admin.users_list.TViewColUsername',
  'Admin.Admin.users_list.TViewColFirstNameUser',
  'Admin.Admin.users_list.TViewColLastNameUser',
  'Admin.Admin.users_list.TViewColUserGroup',
  'Admin.Admin.users_list.TViewColUserEmail',
  'Admin.Admin.users_list.TViewColCompanyName',
  'Admin.Admin.users_list.TViewColUserAddress',
  'Admin.Admin.users_list.TViewColZipCode',
  'Admin.Admin.users_list.TViewColUserManagingParent',
  'Admin.Admin.users_list.TViewColUserOrderingParent',
  'Admin.Admin.users_list.TViewColUserApprovalParent',
  'Admin.Admin.users_list.TViewColTerritory',
  'Admin.Admin.users_list.TViewColActive',
  'Admin.Admin.users_list.TViewColSetTemporaryPassword',
  'Admin.Admin.users_list.TViewColTemporaryPassword',
  'Admin.Admin.users_list.TViewColRetypeTemporaryPassword',
  'UserList.CreatedByUserName',
  'UserList.DateCreated',
  'UserList.ModifiedByUserName',
  'UserList.DateModified',
  'xmlUsers',
  'Admin.AddEditUser.CreateNewUser',
  'Admin.AddEditUser.TotalUsers',
  'Admin.Datatable.ItemsSelected',
  'Admin.Msg.EditTitle',
  'Admin.QPEdit.Permissions',
  'Admin.Home.ImportUsers',
  'Admin.Users.AddNewUser',
  'Admin.UsersDataTable.QuickSearch',
  'Admin.UsersDataTable.EuAccessQuickSearch',
  'Admin.UsersDataTable.EuAccessNoApproverUsers',
  'Admin.StandardTable.LoginAsEuDpUser',
  'Admin.add_edit_ut.LabelSelect',
  'Admin.StandardTable.LoginProxyMouseOver',
  'Admin.AddEditUser.UserBlockedMsg',
  'UserPersonalization.GrantAccessToCPQSupport',
  'UserPersonalization.Until',
  'UserPersonalization.GrantAccessToSupportTicketNumber',
  'UserPersonalization.GrantAccessToCPQSupportDisabledMessage',
  'Admin.add_edit_user.GlobalUserId',
  'xsltCheckIfUserIsInUse',
  'Admin.SetupSpa.Users.UsedInInfoMessage',
  "Admin.Users.LicenseType",
  'Admin.Users.MarkedForDeletion',
  'Admin.Users.MarkedForDeletion.InfoMessage',
  'Menu.ScriptWorkbench',
  'DeveloperConsole.Debugger',
  'AddEditUser.EuAccessManagement',

  // Add company
  'Admin.company_list.QuickSearch',
  'Admin.AddCompany.AddNewCompany',
  'Admin.AddCompany.CompanyCode',
  'Admin.Add_Edit_Cm_Ps.AccountID',
  'Admin.MerchantDataF.MsgCreateCustomerRecord',
  'Admin.MerchantDataF.LabelFax',
  'Admin.MerchantDataF.LabelEmail',
  'xmlCompanies',
  'Admin.MerchantDataF.MsgDownloadDeleteInfo',
  'admin.merchantdataf.CompaniesAreOrganizations',
  'Admin.AddEditUser.Country',
  // Add User Type Dialog
  'Admin.AddUserTypeDialog.Title',
  'Admin.AddUserTypeDialog.Warn',
  'Admin.AddEditUserType.LabelDescription',
  // Add User Company Dialog
  'Admin.AddCompanyDialog.Warn',
  // Add / Edit User - Address Tab
  'Admin.Address',
  'Admin.add_edit_user.LabelAddress1',
  'Admin.add_edit_user.LabelAddress2',
  'Admin.add_edit_user.LabelCity',
  'Admin.add_edit_user.LabelProvince',
  'Admin.add_edit_user.LabelZIPCode',
  'Admin.add_edit_user.LabelCountry',
  'Admin.add_edit_user.LabelState',
  'Admin.add_edit_user.LabelPhone',
  'Admin.add_edit_user.LabelFax',
  'Admin.add_edit_user.LabelTerritory',
  'Admin.add_edit_user.LabelIDCode',
  'Admin.add_edit_user.LabelTitle',
  'Admin.Add_Edit_Cm_Ps.AccountID',
  'Admin.MerchantDataF.MsgCreateCustomerRecord',
  'Admin.Msg.CancelButton',
  'Admin.Msg.Save',
  // User general Tab
  'Admin.add_edit_user.MsgSystemUsername',
  'Admin.UserGeneral.FirstName',
  'Admin.Admin.users_list.TViewColActive',
  'Admin.UserGeneral.LastName',
  'Admin.UserGeneral.Email',
  'Admin.UserGeneral.Username',
  'Admin.UserGeneral.IsSsoUser',
  'Admin.UserGeneral.Password',
  'Admin.UserGeneral.RetypePassword',
  'Admin.UserGeneral.UserType',
  'Admin.UserGeneral.Administrator',
  'Admin.UserGeneral.Company',
  'Admin.UserGeneral.AddNewCompany',
  'Admin.UserGeneral.Branding',
  'Admin.deflusersetup.PlaceholderForSelectCompany',
  'Admin.ErrorMessage.PasswordDifferentFromUsername',
  // User Date and market tab (Date and Number Settings)
  'Admin.DateAndMarket.DateFormat',
  'Admin.AddEdituser.personalization.dateSeparator',
  'Admin.add_edit_user.LabelNumberFormat',
  'Admin.add_edit_user.LabelUserTimeZone',
  'Admin.AddEditUser.ShowQuotesWithin',
  'Admin.AddEditUser.DefaultMarket',
  'Admin.add_edit_user.AllowUserToChangeTimeZone',
  'Admin.AddEditUser.DateAndNumberSettings',
  // User Additional settings tab
  'Admin.AdditionalSettings',
  'UserPersonalization.DefaultPricebook',
  'Admin.AddEditUser.DefaultDictionary',
  'UserList.UserApproveParent',
  'Admin.users.TViewColManagingParent',
  'UserList.UserOrderingParent',
  'Admin.add_edit_user.FederationId',
  'Admin.MarketSettings',
  'Admin.Hierarchy',
  // Guest User
  'Admin.NewSetup.GuestUserSettings',
  'Admin.NewSetup.GuestUser',
  'Admin.NewSetup.DefaultUserSettings',
  'Admin.GuestUser.CancelWarning',
  'Admin.GuestUser.Warning',
  'Admin.AddEditUser.CustomFields',
  'Admin.deflusersetup.LabelGuestUserSettingsHint',
  'Admin.deflusersetup.LabelDefUserSettings4SelfregistrationHint',
  'Admin.deflusersetup.LabelOtherSettingsHint',
  'Admin.GuestUser.LegacySSOSettings',
  // Guest User - General tab
  'Admin.deflusersetup.CustomMessage',
  'Admin.deflusersetup.SSOKey',
  'Admin.deflusersetup.SSOVector',
  'Admin.deflusersetup.SSOQuoteLink',
  // Guest User - Guest user tab
  'Admin.deflusersetup.PlaceholderForSelectUser',
  'Admin.deflusersetup.LabelGuestCannotAddToQuote',
  'Admin.deflusersetup.LabelGuestCanDoCheckoutWithoutRegistration',
  'Admin.deflusersetup.LabelDefaultCustomerRolesForGuestUser',
  'Admin.deflusersetup.LabelEnableSelfRegistring',
  // Guest User - User Registration tab
  'Admin.deflusersetup.LabelEnableSelfRegistring',
  'Admin.deflusersetup.LabelUserGroup4SelfregisteredUsers',
  'Admin.deflusersetup.PlaceholderForSelectUserType',
  'Admin.deflusersetup.LabelDefPassExpPeriod4SelfregisteredUsers',
  'Admin.deflusersetup.LabelOrderParent4SelfregistatedUsers',
  'Admin.deflusersetup.PlaceholderForSelectUser',
  'Admin.deflusersetup.LabelManagParent4SelfregistatedUsers',
  'Admin.deflusersetup.PlaceholderForSelectUser',
  'Admin.deflusersetup.OptionalFieldsForSelfRegisteringUsers',
  'Admin.deflusersetup.LabelRequiredFileds',
  'Admin.deflusersetup.RequiredFields',
  'Admin.deflusersetup.UserCustomFields',
  'Admin.deflusersetup.OptionalFields',
  'Admin.deflusersetup.AvailableAdministrators',
  'Admin.deflusersetup.SelectedAdministrators',
  'UserPersonalization.EuAccessCamUsers',
  'UserPersonalization.EuAccessCamSelectUsers',
  'Admin.deflusersetup.SelectedAdministrators.InfoMessage',
  'Admin.deflusersetup.registerUserAsActive.InfoLabel',
  'Admin.deflusersetup.AvailableAdministrators.InfoLabel',
  'Admin.appParams.AllowUserRegistration',
  'Admin.deflusersetup.Active',
  // Password settings dialog
  'Admin.AddEditUser.PasswordSettingsAndRules',
  'Admin.AddEditUser.LabelMustChPassAtNextLogin',
  'Admin.AddEditUser.LabelExpDate',
  'Admin.AddEditUser.LeaveBlankForPermanentPasswords',
  'UserRegistration.PasswordRules',
  // Permission Groups
  'Admin.CpqPermissionsList.QuickSearch',
  'Admin.CpqPermissionsList.AddNew',
  'Admin.Msg.EditTitle',
  'Admin.AddEditPermission.Title',
  'Admin.CpqPermissionsList.LabelPermissionName',
  'Admin.CpqPermissionsList.LabelPermissionDescription',
  'xmlPermissions',
  'Admin.UsersPermissionGroups.Advanced',
  'Admin.AddEditPermission.LabelAvailableUsers',
  'Admin.CpqPermissionsList.InfoMsg',
  'Admin.AddEditPermission.Help',
  'AddEditPermission.HowPermissionGroupsWorkPart1',
  'AddEditPermission.HowPermissionGroupsWorkPart2',
  'Admin.CpqPermissionsList.LabelPermissionFields',
  'Admin.AddEditPermission.AdvancedModeNotification',
  'Admin.AddEditPermission.SeeUsersWhoBelongTo',
  'Admin.AddEditPermission.UsersWhoBelongTo',
  'UserList.brandname',
  'xmlPermissionsStartTyping',
  'Msg.FilterCriteria',
  'Msg.LogicOR',
  'Msg.LogicAND',
  // User Type
  'Admin.UserTypeList.QuickFilter',
  'Admin.UserTypeList.TotalUserTypes',
  'Admin.UserTypeList.AddNewUserType',
  'Admin.UserTypeList.Edit',
  'Admin.UserTypeList.UserTypeGroup',
  'Admin.UserTypeList.UserTypeGroupDesc',
  'Admin.UserTypeList.UserTypeStartPage',
  'Admin.UserTypeList.UserTypeXSLT',
  'Admin.UserTypeList.UserTypeStartCategory',
  'Admin.UserTypeList.UserTypeAllowIncomplete',
  'Admin.UserTypeList.UserTypeInconsistentItems',
  'Admin.AddEditUserType.LabelAllowAddingInconsistentItems',
  'Admin.CpqPermissionsList.LabelPermissionFields',
  'Admin.AddEditPermission.LabelPermissionGroupDescription',
  'Admin.AddEditUserType.LabelNotVisibleViews',
  'Admin.add_edit_ut.JSMSGAtLeastOneView',
  'Admin.AddEditUserType.LabelDisplayTreeNavigation',
  'Admin.RDTemplateList.TotalRDTemplates',
  // User Custom Fields
  'UserCustomFields.AddNew',
  'UserCustomFields.Total',
  'UserCustomFields.Edit',
  'UserCustomFields.Name',
  'UserCustomFields.Label',
  'UserCustomFields.Type',
  // Translate User Custom Fields
  'UserCustomFields.Translate',
  'UserCustomFields.Translation.DefaultLanguage',
  'Admin.CustomFields.AddNewTranslation',
  'Admin.Multilanguage',
  'Admin.SelectLanguage',
  // Company
  'Admin.company_list.TViewColCompanyName',
  'Admin.company_list.TViewColCompanyCode',
  'Admin.company_list.TViewColCompanyAddress',
  'Admin.company_list.TViewColCompanyCity',
  'Admin.company_list.TViewColState',
  'Admin.company_list.TotalCompanies',
  'Admin.company_list.AddNewCompany',
  'Admin.admin_customer_list.TViewColCRMAccountID',
  'Admin.add_edit_global_customer.LabelCRMContactIDLink',
  'Admin.AddEditCompany.LabelCrmLookupInfo',
  // Add/Edit User
  'Admin.AddEditUserType.LabelGroupName',
  'Admin.AddEditUserType.LabelDescription',
  'Admin.AddEditUserType.LabelStartPage',
  'Admin.AddEditUserType.LabelDefaultCategoryView',
  'Admin.AddEditUserType.RequireCustomerToBeSelected',
  'Admin.AddEditUserType.LabelShowFields',
  'Admin.AddEditUserType.LabelShowPrices',
  'Admin.AddEditUserType.LabelAllowIncomingConfigurations',
  'xmlUserGroups',
  'Admin.company_list.CreateNewCompany',
  'Admin.MerchantDataF.LabelCompanyLogo',  
  // Add-Edit User types
  'xmlUserCustomFields',
  'CustomerFieldsPermissions.Editable',
  'Admin.QPEdit.ReadDashOnly',
  'Admin.QPEdit.Required',
  'Admin.Clear',
  'Admin.Msg.EditTitle',
  'Admin.AddEditUserType.CreateNew',
  'Admin.AddEditUserType.LabelStartCategory',
  'Admin.ResponsiveUITemplate.UIDesign',
  'Admin.Responsive.SelectPage',
  'Admin.Responsive.SelectTemplate',
  'Admin.Responsive.SelectCustomTemplate',
  'Admin.ResponsiveUITemplate.PageName',
  'Admin.ResponsiveUITemplate.TemplateName',
  'Admin.ResponsiveUITemplate.CustomTemplateName',
  'Admin.Responsive.IsDefault',
  'Admin.ResponsiveUITemplate.AddNew',
  'Admin.ResponsiveUITemplate.QuickFilter',
  // Add-edit user custom field
  'Admin.QPEdit.Hidden',
  'Admin.UserCustomField.Label',
  'Admin.UserCustomField.Type',
  'Admin.UserCustomField.SameForAll',
  'Admin.UserCustomField.FieldPermission',
  'Admin.UserCustomField.CreateNew',
  'Admin.UserCustomField.Attribute',
  'UserCustomFields.Information',
  'ItemActionsList.Multilanguage',
  // Segregation of duties
  'xmlSegregationOfDuties',
  'xmlSetupSections',
  'Admin.SegregationOfDuties.SetupSections.InfoMessage',
  'xmlSelectedSectionsEntries',
  'Admin.SegregationOfDuties.SelectedSectionsEntries.InfoMessage',
  'Admin.SegregationOfDuties.Apply',
  'Admin.SegregationOfDuties.Applied',
  'Admin.SegregationOfDuties.NotApplied',
  'Admin.SegregationOfDuties.SegregationSettings',
  'Admin.SegregationOfDuties.SegregationAdmins',
  'Admin.SegregationOfDuties.SelectSegregationAdmins',
  'Admin.SegregationOfDuties.CancelChangeWarning',
  'Admin.SegregationOfDuties.GrantedAccessIconTitle',
  'Admin.CustomTablesList.CustomTable',
  'Admin.SegregationOfDuties.ApplySegregationSettingsMessage',
  'Admin.SegregationOfDuties.RightsPrevailMessage',
  'Admin.SegregationOfDuties.RightsPrevail',
  'Admin.SegregationOfDuties.RightsPrevailOnMessage',
  'Admin.SegregationOfDuties.RightsPrevailOffMessage',
  'admin.segregation.federation',
  'Admin.FullMarket',
  'dbadmin',
  'Admin.SegregationOfDuties.SegregationHelper',
  'Admin.SegregationOfDuties.SegregationHelper.FindAdministrator',
  'Admin.deflusersetup.PlaceholderForSelectUser',
  'Admin.SegregationOfDuties.SegregationHelper.SectionColumn',
  'Admin.SegregationOfDuties.SegregationHelper.PermissionGroupsColumn',
  'Admin.SegregationOfDuties.PermissionStructure',
  'Admin.SegregationOfDuties.SegregationHelper.Companies',
  'Admin.SegregationOfDuties.SegregationHelper.Brands',
  'Admin.SegregationOfDuties.SegregationHelper.Markets',
  'Admin.SegregationOfDuties.SegregationHelper.UserTypes',
  'Admin.SegregationOfDuties.SegregationHelper.Users',
  'Admin.SegregationOfDuties.SegregationHelper.AdvancedModeInfo',
  'ProductSegregation.Title',
  'ProductSegregation.CanManageAdditionalTabs',
  'ProductSegregation.CanCreateProductTypes',
  'ProductSegregation.PermissionGroupSelectionLabel',
  'CustomTableSegregation.Title',
  'CustomTableSegregation.WarningMessage',
  'CustomTableSegregation.CanAddEditDeleteCustomTables',
  'API.BulkQuoteDelete.CannotDeleteAllQuotes',
  'BulkQuoteDeleteSegregation.Title',
  'BulkQuoteDeleteSegregation.WarningMessage',
  'BulkQuoteDeleteSegregation.CanHardDeleteAllQuotes',
  'ActionsSegregation.Title',
  'ActionsSegregation.CanSeeActions',
  'ActionsSegregation.CanEditActions',
  'ActionsSegregation.WarningMessage',
  'ActionSegregation.Title'
];
